<script setup lang="ts">
import { ref, nextTick } from 'vue'

import ThemeSwitcher from './ThemeSwitcher.vue'
import { LogoutIcon, SettingsIcon } from '@/components/icons'
import {useAuthStore} from '@/stores'
import PrivacySwitch from './PrivacySwitch.vue'

const authStore = useAuthStore()

const showChildren = ref(false)
const expanded = ref(false)
const containerHeight = ref<string | number>(0)
const container = ref<HTMLElement | null>(null)

const toggleMenu = () => {
  expanded.value = !expanded.value

  if (!showChildren.value) {
    showChildren.value = true
    nextTick(() => {
      if (container.value) {
        containerHeight.value = `${container.value.scrollHeight}px`
        setTimeout(() => {
          containerHeight.value = 'fit-content'
          container.value!.style.overflow = 'visible'
        }, 300)
      }
    })
  } else {
    if (container.value) {
      containerHeight.value = `${container.value.scrollHeight}px`
      container.value.style.overflow = 'hidden'
      setTimeout(() => {
        containerHeight.value = '0px'
        container.value!.style.paddingBlock = '0px'
      }, 10)
      setTimeout(() => {
        showChildren.value = false
      }, 300)
    }
  }
}

const doLogout = async () => {
  await authStore.logout();
}

</script>

<template>
  <div class="settings-outer" :class="{ expanded: expanded }">
    <div class="main">
      <div class="button" @click.stop="toggleMenu">
        <SettingsIcon />
        <div>Settings</div>
      </div>
      <div class="line"></div>
      <div class="button" @click="doLogout">
        <LogoutIcon />
        <div>Logout</div>
      </div>
    </div>
    <div
      v-show="showChildren"
      class="items-container"
      ref="container"
      :style="{ height: containerHeight }"
    >
      <div class="settings-item"><ThemeSwitcher /></div>
      <div class="settings-item"><PrivacySwitch /></div>
      <div class="settings-item last"></div>
    </div>
  </div>
</template>

<style scoped>
.settings-outer {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.settings-outer .main {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-inline: auto;
  width: 12.5rem;
  padding-bottom: 0.625rem;
}

.settings-outer .main .line {
  height: 0.9375rem;
  width: 0.0625rem;
  background-color: var(--color-secondary);
}

.settings-outer .main .button {
  display: flex;
  gap: 0.625rem;
  font-size: var(--font-size-body);
  align-items: center;
}

.settings-outer .main .button:hover {
  cursor: pointer;
}

.settings-outer .items-container {
  width: 100%;
  max-width: 18.75rem;
  overflow: hidden;
  transition: height 0.3s ease;
}

.settings-outer .items-container .settings-item {
  position: relative;
  width: 100%;
  height: 1.875rem;
  padding-inline: 0.625rem;
}

.settings-outer .items-container .settings-item.last {
  position: relative;
  width: 100%;
  height: 0.9375rem;
  padding-left: 0.625rem;
}
</style>
